export default __webpack_public_path__ + "static/media/gallery - original vs translated_03.d3f09fc7.jpg";